import React, { Component } from 'react';
import { Button, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../content/css/ContractReviewer.css';
import '../../content/css/ContractReviewerHOCR.css';
import { contractReviewerActions as actions, analysisActions } from '../../actions';
import { contractReviewerConstants } from '../../constants';
import AuthService from '../../services/auth.service';
import Viewer from '../../helpers/documentViewer';
import PageFilterControl from './PageFilterControl';
import DocumentHtmlView from '../DocumentViewer/DocumentHtmlView';
import HighlightMarkers from '../Highlight/HighlightMarkers';
import HighlightTexts from '../Highlight/HighlightTexts';
import TextSelector from 'text-selection-react';
import { LoadingIcon } from '../LoadingIcon';
import PredictTextModal from './PredictTextModal';
import PageThemeFilterControl from './PageThemeFilterControl';
import CompareDocumentsModal from './CompareDocumentsModal';
import LoadingListener from '../../helpers/loadingListener';
import HocrProofreader from '../../helpers/HocrProofreader';
import SummaryModal from './SummaryModal';

var authService = new AuthService();
const DisplayMode = {
    NORMAL: 'NORMAL',
    SHOW_ORIGINAL: 'SHOW_ORIGINAL',
    SHOW_DEVIATION: 'SHOW_DEVIATION',
    SHOW_BASE: 'SHOW_BASE'
};

class HOCRViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            highlights: [],
            selectedHighlight: -1,
            filter: { type: 'predicted', importance: ['low', 'medium', 'high'] },
            lastUpdate: 0,
            textToPredict: "",
            showSummary: false,
            displayMode: DisplayMode.NORMAL,
            comparisonDocumentId: "",
            isDocDisplayed: false
        };

        this.HocrReader = new HocrProofreader({
            layoutContainer: 'layout-container',
            editorContainer: 'editor-container'
        });
        this.loadingListener = new LoadingListener([contractReviewerConstants.GET_DOCUMENT_ANALYSIS_REQUEST]);
    }

    componentDidMount() {
        const { reportId, docId, clause } = this.props.match.params;

        if (reportId && this.props.reportId !== reportId) {
            this.props.requestPortfolioAnalysis(reportId);
        }

        if (this.props.id !== docId || this.props.shouldRefreshAnalysis) {
            this.props.requestDocumentAnalysis(docId, reportId);
            this.requestSummaryAndFeedback(docId);
            this.HocrReader.init();
        }
        else {
            this.setHOCR();
            let doc = this.getCurrentDocument();
            if (doc && !doc.summary)
                this.requestSummaryAndFeedback(docId);
        }
        this.applyFilter(this.state.filter, this.state.filter, true);
        this.selectHighlight(parseInt(clause) - 1);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.analyzedDocuments !== prevProps.analyzedDocuments) {
            let oldDocument = this.getCurrentDocument(prevProps);
            let newDocument = this.getCurrentDocument();

            if (oldDocument != newDocument) {
                this.setHOCR();
            }

            if (newDocument.highlights !== oldDocument.highlights) {
                if (this.state.filter.type === 'predicted') {
                    this.applyFilter(this.state.filter, prevState.filter, true);
                    //this.selectHighlight(0);
                }
            }

            if (newDocument.segments !== oldDocument.segments) {
                if (this.state.filter.type === 'all') {
                    if (newDocument.segments.length !== 0 || oldDocument.segments.length !== 0) {
                        this.applyFilter(this.state.filter, prevState.filter, true);
                        //this.selectHighlight(0);
                    }
                }
            }
        }

        if (this.props.shouldRefreshAnalysis) {
            setTimeout(() => this.props.requestDocumentAnalysis(this.props.id), this.props.refreshAnalysisDelay * 1000);
        }

        if (this.state.displayMode !== prevState.displayMode) {
            this.applyFilter(this.state.filter, prevState.filter, true);
        }

        if (this.state.filter !== prevState.filter) {
            this.applyFilter(this.state.filter, prevState.filter);
        }

        if (this.didHighlightsUpdateEnoughForRedraw(this.state.highlights, prevState.highlights)) {
            if (this.state.displayMode == DisplayMode.NORMAL) {
                this.setHOCR();
            } else {
                Viewer.highlight(this.state.highlights, document.querySelector("#main-document-view .document-html"), this.handleHighlightDone);
            }
        }

        //Hook click events to all highlighted text elements.
        if (this.state.lastUpdate !== prevState.lastUpdate) {
            this.updateHighlightedTextEventListeners();
            Viewer.scrollIntoView(this.state.selectedHighlight);
        }

        if (this.state.selectedHighlight !== prevState.selectedHighlight && this.state.lastUpdate !== 0) {
            Viewer.scrollIntoView(this.state.selectedHighlight);
        }

        if (this.props.exceptions != prevProps.exceptions && this.props.exceptions.length > 0) {
            throw this.props.exceptions[0];
        }
    }

    requestSummaryAndFeedback = (docId) => {
        if (!authService.userAllowsThirdPartyAI())
            return;

        this.props.getDocumentSummaryAndFeedback(docId);
    }

    didHighlightsUpdateEnoughForRedraw(newHighlights, oldHighlights) {
        if (newHighlights && !oldHighlights) return true;
        if (newHighlights.length != oldHighlights.length) return true;

        for (let i = 0; i < newHighlights.length; i++) {
            if (newHighlights[i].id != oldHighlights[i].id) return true;
        }

        return false;
    }

    async setHOCR() {

        let doc = this.getCurrentDocument();
        let isDocReady = doc.documentHtml !== "" && doc.images && Object.keys(doc.images).length !== 0;
        if (isDocReady && !this.state.isDocDisplayed) {
            let self = this;
            await new Promise((resolve, reject) => {
                self.HocrReader.setHocr(doc.documentHtml, doc.images);
                self.setState({ isDocDisplayed: true });
                resolve();
            });
        }

        if (isDocReady && this.state.highlights.length > 0) {
            let element = document.getElementById("main-document-view");
            Viewer.highlightTextSegments(this.state.highlights, element);
            this.handleHighlightDone();
        }
    }

    getCurrentDocument = (props = this.props) => {
        let id = props.id;
        if (this.state.displayMode == DisplayMode.SHOW_BASE) id = this.state.comparisonDocumentId;
        else if (this.state.displayMode == DisplayMode.SHOW_DEVIATION) id = `${props.id}-${this.state.comparisonDocumentId}`;

        let doc = props.analyzedDocuments[id];
        doc = doc ? doc : {
            summary: "",
            highlights: [],
            missingHighlights: [],
            segments: []
        };

        return doc;
    }

    getComparisonDocument = () => {
        return this.props.analyzedDocuments[this.state.comparisonDocumentId];
    }

    applyFilter = (filter, prevFilter, force = false) => {
        if (filter.type === 'all' && (prevFilter.type !== 'all' || force)) {
            if (this.getCurrentDocument().segments.length == 0) this.props.requestDocumentSegments(this.props.id);
            else this.setState({ highlights: this.getCurrentDocument().segments });
        }
        else if (filter.type === 'predicted' && (prevFilter.type !== 'predicted' || force))
            this.setState({ highlights: this.getFilterHighlights(this.getCurrentDocument().highlights) });
        else if (filter.type === 'predicted') {
            this.setState({ highlights: this.getFilterHighlights(this.getCurrentDocument().highlights) });
        }
    }

    getFilterHighlights = (highlights) => {
        let result = [...highlights];
        if (!this.state.filter.importance.includes('low')) result = result.filter(x => x.risk !== 0);
        if (!this.state.filter.importance.includes('medium')) result = result.filter(x => x.risk !== 1);
        if (!this.state.filter.importance.includes('high')) result = result.filter(x => x.risk !== 2);

        return result;
    }

    updateHighlightedTextEventListeners = () => {
        var highlightElements = document.getElementsByClassName("highlight");

        Array.from(highlightElements).forEach((element, i) => {
            var index = parseInt(element.dataset.highlightId);
            var highlight = this.state.highlights[index];
            element.removeEventListener("click", () => this.handleHighlightItemClick(highlight, index));
            element.addEventListener("click", () => this.handleHighlightItemClick(highlight, index));
        });
    }

    handleHighlightItemClick = (highlight, i) => {
        this.selectHighlight(i);
    }

    handleGotoPreviousClick = () => {
        var selected = Math.max(this.state.selectedHighlight - 1, 0);
        this.selectHighlight(selected);
    }

    handleGotoNextClick = () => {
        var selected = Math.min(this.state.selectedHighlight + 1, this.state.highlights.length - 1);
        this.selectHighlight(selected);
    }

    handleCreateSegment = (html, text) => {
        var selection = window.getSelection();

        var selectionRange = selection.getRangeAt(0);
        let startNode = selection.anchorNode;
        let startOffset = selectionRange.startOffset;

        //let rootNode = document.getElementsByClassName('document-html')[0]
        let rootNode = document.querySelector('#main-document-view .document-html');
        let originRange = document.createRange();
        originRange.setStart(rootNode, 0);
        originRange.setEnd(startNode, startOffset);

        startOffset = originRange.toString().length;
        let endOffset = startOffset + selectionRange.toString().length;

        //console.log("Selection starts at: " + startOffset);
        //console.log("Selection ends at: " + endOffset);

        this.props.addTextSegment(this.props.id, html, text, startOffset);
    }

    handlePredictSegment = (html, text) => {
        this.setState({ textToPredict: text });
    }

    handleHighlightDone = (result) => {
        this.setState({ lastUpdate: new Date().getMilliseconds() });
    }

    selectHighlight = (index) => {
        this.setState({
            selectedHighlight: index
        });
    }

    handleFilterChange = (filter, prevFilter) => {
        this.setState({ filter });
    }

    handleNotesChange = (textSegmentId, categoryCode, notes) => {
        this.props.editHighlightNotes(this.props.id, textSegmentId, categoryCode, notes);
    }

    handleIsSelectedChange = (textSegmentId, categoryCode, isSelected) => {
        this.props.editHighlightIsSelected(this.props.id, textSegmentId, categoryCode, isSelected);
    }

    handleThemeChange = (themeId) => {
        this.props.requestDocumentAnalysis(this.props.id, themeId);
    }

    handleCompareDocuments = (id) => {
        /*let doc = this.getCurrentDocument();
        let other = this.props.analyzedDocuments[id];
        this.props.requestCompareDocuments(doc, other);*/
        this.setState({ displayMode: DisplayMode.SHOW_DEVIATION, comparisonDocumentId: id });
    }

    handleDisplayModeChange = (value) => {
        this.setState({ displayMode: value });
    }

    handleToggleSummaryModal = () => {
        let showSummary = !this.state.showSummary;
        this.setState({ showSummary });
    }

    render() {
        let isAdmin = authService.isAdmin();
        let hasDeviationAccess = authService.hasDeviationAccess();
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let doc = this.getCurrentDocument();
        let isSummaryReady = doc && doc.summary;

        return (
            <React.Fragment>
                {isLoading &&
                    <LoadingIcon isFixed={true} />
                }

                {isAdmin &&
                    <React.Fragment>
                        <TextSelector
                            events={[
                                {
                                    text: 'Add sentence',
                                    handler: this.handleCreateSegment
                                },
                                {
                                    text: 'Test on concepts',
                                    handler: this.handlePredictSegment
                                }
                            ]}
                            color={'yellow'}
                            colorText={false}
                        />

                        <PredictTextModal text={this.state.textToPredict} />
                    </React.Fragment>
                }

                {!isLoading &&
                    <React.Fragment>
                        <Col className="wrapper-left">
                            <div className="fixed-toolbar">
                                {isAdmin &&
                                    <PageFilterControl initialValue={this.state.filter} isAdmin={isAdmin} onToggle={this.handleFilterChange} />
                                }
                                {(isAdmin || hasDeviationAccess) &&
                                    <div className="compare-document-toolbar">
                                        <CompareDocumentsModal onConfirm={this.handleCompareDocuments} onExitMode={() => this.handleDisplayModeChange(DisplayMode.NORMAL)} />
                                        {this.state.displayMode != DisplayMode.NORMAL &&
                                            <ButtonToolbar>
                                                <ToggleButtonGroup type="radio" name="type" value={this.state.displayMode} onChange={this.handleDisplayModeChange}>
                                                    <ToggleButton value={DisplayMode.SHOW_BASE}>Template</ToggleButton>
                                                    <ToggleButton value={DisplayMode.SHOW_DEVIATION}>Deviation</ToggleButton>
                                                    <ToggleButton value={DisplayMode.SHOW_ORIGINAL}>Document</ToggleButton>
                                                </ToggleButtonGroup>
                                            </ButtonToolbar>
                                        }
                                    </div>
                                }
                                {isAdmin && authService.userAllowsThirdPartyAI() &&
                                    <div className="center-content">
                                        {isSummaryReady &&
                                            <Button onClick={this.handleToggleSummaryModal}>Show summary <Glyphicon glyph="alt-list" /></Button>
                                        }
                                        {!isSummaryReady &&
                                            <Button>Summary loading... <Glyphicon glyph="refresh" className="spinning" /></Button>
                                        }

                                        <SummaryModal
                                            data={doc.summary}
                                            last week
                                            show={this.state.showSummary}
                                            onClose={this.handleToggleSummaryModal}
                                        />
                                    </div>
                                }
                            </div>
                            <HighlightTexts
                                isLoading={isLoading}
                                isAdmin={isAdmin}
                                highlights={this.state.highlights}
                                lastUpdate={this.state.lastUpdate}
                                selectedHighlight={this.state.selectedHighlight}
                                filterType={this.state.filter.type}
                                onDelete={this.props.deleteTextSegment}
                                onNotesChange={this.handleNotesChange}
                                onSelectChange={this.handleIsSelectedChange}
                            />
                        </Col>

                        <Col className="wrapper-main">
                            <h1>Legly</h1>
                            <span><strong>File:</strong> {this.getCurrentDocument().fileName}</span>
                            <div className="document-view" id="main-document-view">
                                <HighlightMarkers
                                    isLoading={isLoading}
                                    highlights={this.state.highlights}
                                    lastUpdate={this.state.lastUpdate}
                                    selectedHighlight={this.state.selectedHighlight}
                                    onItemClick={this.handleHighlightItemClick}
                                />

                                {this.state.displayMode == DisplayMode.NORMAL &&
                                    <div>
                                        <div id="layout-container" className="container"></div>
                                        <div id="editor-container"></div>
                                    </div>
                                }
                                {this.state.displayMode != DisplayMode.NORMAL &&
                                    <div>
                                        <DocumentHtmlView html={this.getCurrentDocument().documentHtml} />
                                    </div>
                                }

                            </div>
                        </Col>

                        <Col className="wrapper-right">
                            {isAdmin &&
                                <PageThemeFilterControl themeName={this.getCurrentDocument().themePackageName} onChange={this.handleThemeChange} />
                            }
                            <div className='navigation-wrapper'>
                                <Button className='navigate-clauses up' onClick={this.handleGotoPreviousClick}>
                                    <Glyphicon glyph='arrow-up' /> Previous
                                </Button>
                                <Button className='navigate-clauses down' onClick={this.handleGotoNextClick}>
                                    <Glyphicon glyph='arrow-down' /> Next
                                </Button>
                            </div>
                        </Col>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

export default connect(
    state => {
        return {
            ...state.contractReviewer,
            reportId: state.analysis.id
        };
    },
    dispatch => bindActionCreators({
        ...actions,
        requestPortfolioAnalysis: analysisActions.requestPortfolioAnalysis
    }, dispatch)
)(HOCRViewer);



// WEBPACK FOOTER //
// ./src/components/DocumentViewer/HOCRViewer.js